"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenToCreateHtml = exports.PrintOrientation = void 0;
var Accordion_1 = require("./Accordion");
var Models_1 = require("../Models");
var BasicBlocks_1 = require("./BasicBlocks");
var Button_1 = require("./Button");
var GoogleMaps_1 = require("./GoogleMaps");
var Image_1 = require("./Image");
var Iframe_1 = require("./Iframe");
var LineBreak_1 = require("./LineBreak");
var ListItem_1 = require("./ListItem");
var MediaVariable_1 = require("./MediaVariable");
var ROICalculator_1 = require("./ROICalculator");
var SideBySide_1 = require("./SideBySide");
var Table_1 = require("./Table");
var TokenWidget_1 = require("./TokenWidget");
var Variables_1 = require("./Variables");
var Video_1 = require("./Video");
var Text_1 = require("./Text");
var Link_1 = require("./Link");
var ContentLoop_1 = require("./ContentLoop");
var PrintOrientation;
(function (PrintOrientation) {
    PrintOrientation["Portrait"] = "portrait";
    PrintOrientation["Landscape"] = "landscape";
})(PrintOrientation = exports.PrintOrientation || (exports.PrintOrientation = {}));
exports.tokenToCreateHtml = new Map();
exports.tokenToCreateHtml.set(Models_1.BlockType.Accordion, Accordion_1.createHtmlFromAccordion);
exports.tokenToCreateHtml.set(Models_1.BlockType.HorizontalRule, BasicBlocks_1.createHtmlFromHorizontalRule);
exports.tokenToCreateHtml.set(Models_1.BlockType.Paragraph, (0, BasicBlocks_1.makeCreateHtmlFromBasicBlock)("paragraph"));
exports.tokenToCreateHtml.set(Models_1.BlockType.Heading1, (0, BasicBlocks_1.makeCreateHtmlFromBasicBlock)("heading1"));
exports.tokenToCreateHtml.set(Models_1.BlockType.Heading2, (0, BasicBlocks_1.makeCreateHtmlFromBasicBlock)("heading2"));
exports.tokenToCreateHtml.set(Models_1.BlockType.BlockQuote, (0, BasicBlocks_1.makeCreateHtmlFromBasicBlock)("blockQuote"));
exports.tokenToCreateHtml.set(Models_1.BlockType.Button, Button_1.createHtmlFromButton);
exports.tokenToCreateHtml.set(Models_1.BlockType.ContentLoop, ContentLoop_1.createHtmlFromContentLoop);
exports.tokenToCreateHtml.set(Models_1.BlockType.GoogleMaps, GoogleMaps_1.createHtmlFromGoogleMaps);
exports.tokenToCreateHtml.set(Models_1.BlockType.Iframe, Iframe_1.createHtmlFromIframe);
exports.tokenToCreateHtml.set(Models_1.BlockType.Image, Image_1.createHtmlFromImage);
exports.tokenToCreateHtml.set(Models_1.InlineType.LineBreak, LineBreak_1.createHtmlFromLineBreak);
exports.tokenToCreateHtml.set(Models_1.InlineType.Link, Link_1.createHtmlFromLink);
exports.tokenToCreateHtml.set(Models_1.BlockType.ListItem, ListItem_1.createHtmlFromListItem);
exports.tokenToCreateHtml.set(Models_1.BlockType.MediaVariable, MediaVariable_1.createHtmlFromMediaVariable);
exports.tokenToCreateHtml.set(Models_1.BlockType.ROICalculator, ROICalculator_1.createHtmlFromROICalculator);
exports.tokenToCreateHtml.set(Models_1.BlockType.SideBySide, SideBySide_1.createHtmlFromSideBySide);
exports.tokenToCreateHtml.set(Models_1.BlockType.Table, Table_1.createHtmlFromTable);
exports.tokenToCreateHtml.set(Models_1.InlineType.TokenWidget, TokenWidget_1.createHtmlFromTokenWidget);
exports.tokenToCreateHtml.set(Models_1.InlineType.Variable, Variables_1.createHtmlFromVariable);
exports.tokenToCreateHtml.set(Models_1.BlockType.Video, Video_1.createHtmlFromVideo);
exports.tokenToCreateHtml.set(Models_1.BlockType.Caption, (0, BasicBlocks_1.makeCreateHtmlFromBasicBlock)("paragraph"));
exports.tokenToCreateHtml.set("text", Text_1.createHtmlFromText);
